// Mint-Home-1920 · N-04e: bảng phải (vai sale) — Thông báo + Mail hộp chung, theo code board (NOTIS, MAILQ.sale).
export const NOTIS_SALE: readonly (readonly [string, string, 'warn' | 'err' | 'pri' | 'ok' | 'violet', boolean])[] = [
  ['Khách NAMMY yêu cầu sửa Draft B/L SE260615950', '10 phút trước', 'warn', true],
  ['WAN HAI 372 E031 lùi ETD sang 24/Oct/2026 · 3 job', '35 phút trước', 'err', true],
  ['TUANNT gửi đơn nghỉ phép 24/Oct/2026 · chờ duyệt', '1 giờ trước', 'pri', false],
  ['Debit DN26050412 đã được khách xác nhận', 'hôm qua 16:20', 'ok', false],
  ['Báo giá Live GREENBUD: 4 dòng giá đổi', 'hôm qua 09:00', 'violet', false],
];
// [id, hộp, người gửi, tiêu đề, SLA, tone, chưa đọc]
export const MAIL_SALE: readonly (readonly [string, string, string, string, string, 'warn' | 'err' | 'tx', boolean])[] = [
  ['m7', 'support@', 'Anh Tâm · RUITONGVN-SC', 'Xin telex release HBL HNSGN260639142', 'còn 18 phút', 'warn', true],
  ['m2', 'info@', 'ONE Customer Service', 'Cancelled booking SGNGN0063700 · chưa gán PIC', 'quá SLA 7 phút', 'err', true],
  ['m11', 'Hộp của tôi', 'Sales Desk · ANDG', 'Hỏi giá CLI → JEA 2×20DC · NDP', 'còn 40 phút', 'tx', false],
];
